type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const STANDARD_CHARGES_INVOICE: Header[] = [
  {
    key: "standardChargeNote",
    label: "Charge Name",
    style: { width: "30%" },
  },
  {
    key: "totalQuantityPgLn",
    label: "Qty / No. of Pages",
    style: { width: "13%" },
    isNumeric: true,
  },
  {
    key: "invoiceLineItemStatus",
    label: "Invoice Status",
    style: { width: "15%" },
  },
  {
    key: "generatedBy",
    label: "Added On | By",
    style: { width: "25%" },
  },
  {
    key: "fixedFlatRate",
    label: "Amount",
    style: { width: "13%" },
    isNumeric: true,
  },

  {
    key: "actions",
    label: "Action",
    style: { width: "10%" },
  },
];

export const INVOICE_LINE_ITEMS: Header[] = [
  {
    key: "billingForUserFullName",
    label: "User / Role",
    style: { width: "7%", minWidth: "200px" },
  },
  {
    key: "appointmentInfo",
    label: "Appointment Date & Time",
    style: { width: "7%", minWidth: "180px" },
  },
  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "7%", minWidth: "180px" },
  },
  {
    key: "totalNoOfPages",
    label: "No. of Pages",
    isNumeric: true,
    style: { width: "7%", minWidth: "150px" },
  },
  {
    key: "totalNoOfLines",
    label: "No. of Lines",
    isNumeric: true,
    style: { width: "7%", minWidth: "150px" },
  },

  {
    key: "billingRuleRate",
    label: "Rate",
    isNumeric: true,
    style: { width: "7%", minWidth: "150px" },
  },
  {
    key: "invoiceLineItemStatus",
    label: "Invoice Status",
    style: { width: "7%", minWidth: "175px" },
  },
  {
    key: "totalAmount",
    label: "Amount",
    isNumeric: true,
    style: { width: "7%", minWidth: "120px" },
  },

  {
    key: "isActive",
    label: "Is Active?",
    style: { width: "7%", minWidth: "150px" },
  },

  {
    key: "generatedBy",
    label: "Added On | By",
    style: { width: "7%", minWidth: "260px" },
  },

  {
    key: "actions",
    label: "Action",
    style: { width: "10%", minWidth: "80px" },
  },
];

export const INVOICE_COMMENTS: Header[] = [
  {
    key: "userComment",
    label: "Comments",
    style: { width: "40%" },
  },
  {
    key: "uploadedBy",
    label: "Uploaded On | By",
    style: { width: "13%" },
    isNumeric: true,
  },

  {
    key: "actions",
    label: "Action",
    style: { width: "10%" },
  },
];
